<template>
  <v-data-table 
    :headers="headers" 
    :items="users" 
    item-key="id" 
    :page="page"
    :items-per-page="itemsPerPage" 
    :loading="loading"
    class="elevation-1 table text-center align-middle small" 
    loading-text="Cargando..." 
    mobile-breakpoint="0" 
    :header-props="{ sortIcon: 'fa-solid fa-up-down' }"
    :footer-props="{
      'items-per-page-text': 'Mostrando: ',
      'items-per-page-options': [5, 10, 20, 30, 40, 50],
    }"
    hide-default-footer
  >
    <template v-slot:item="{ item, index }">
      <UserTableRow
        :user="item"
        :index="index"
        :show-tutorial="showTutorial && index === 0"
        @edit="$emit('edit-user', item)"
        @close-tutorial="$emit('close-tutorial')"
        @open-tutorial-video="$emit('open-tutorial-video')"
      />
    </template>

    <template v-slot:footer>
      <div class="text-center pt-2">
        <v-pagination 
          :value="page"
          :length="pageCount"
          :total-visible="6" 
          next-icon="fas fa-angle-right"
          prev-icon="fas fa-angle-left"
          @input="$emit('page-change', $event)"
        />
      </div>
    </template>
  </v-data-table>
</template>

<script>
import UserTableRow from './UserTableRow.vue'

export default {
  name: 'UserDataTable',
  
  components: {
    UserTableRow
  },

  props: {
    users: { type: Array, default: () => [] },
    headers: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    page: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
    pageCount: { type: Number, default: 0 },
    showTutorial: { type: Boolean, default: false }
  },

  emits: [
    'edit-user', 
    'page-change', 
    'items-per-page-change',
    'close-tutorial',
    'open-tutorial-video'
  ]
}
</script>